module.exports = "/img/twitter_summarycard_large.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter_summarycard_large.png
// module id = 490
// module chunks = 0